<!--//@*/*text
//    *RPD Baording App 0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//-->

<template>
  <Transition name="scroll-y-reverse-transition" mode="out-in">
    <v-container class="cmpbk black--text" id="home-container">
      <v-row no-gutters>
        <!--auththentication!!!!!-->
        <auth></auth>
      </v-row>
      <!-- dialog -->
      <v-row v-if="dialog">
        <v-col>
          <addedit_diag
            :dialog="dialog"
            :per_email_warning="per_email_warning"
            :mod_state="mod_state"
            :new_emp="new_emp"
            :emp_types="emp_types"
            @close_dialog="close_dialog"
            @save_added_emp="save_added_emp"
            @per_email_warning_now="per_email_warning_now"
          >
          </addedit_diag>
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0">
        <v-col cols="12" class="pt-0">
          <v-btn
            color="secondary"
            @click.prevent="open_dialog"
            style="width: 100%"
          >
            <v-icon>$plus</v-icon>
            Add New EMPLOYEE
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <!--Search!!!!!-->
        <v-col id="searchcol" cols="12">
          <div class="rect">
            <v-expansion-panels v-model="search_expn" accordion>
              <v-expansion-panel>
                <v-expansion-panel-header color="searchhdr" class="white--text">
                  Search
                  <template v-slot:actions>
                    <v-icon color="secondary"> $chevup </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="searchbk">
                  <v-form v-model="valid">
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <h3>FILL IN SOME SOME FIELD(S) BELOW</h3>
                          <hr />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="search_term.fname"
                            :counter="60"
                            label="First name"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="search_term.lname"
                            :counter="60"
                            label="Last name"
                          >
                          </v-text-field>
                        </v-col>

                        <!-- <v-col cols="12" md="3">
                          <v-text-field
                            v-model="search_term.dob"
                            type="date"
                            :counter="10"
                            label="DOB"
                          >
                          </v-text-field>
                        </v-col> -->
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="search_term.badge_emp_num"
                            :counter="25"
                            label="Badge/Emp#"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            style="background-color: transparent"
                            :items="units"
                            v-model="search_term.unit"
                            label="Unit"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            :items="div_names"
                            v-model="search_term.division"
                            label="Division"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="search_term.notes"
                            :counter="60"
                            label="Notes"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            required
                            :items="del_intems"
                            v-model="search_term.deleted"
                            label="Completed?"
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            rounded
                            color="secondary"
                            @click.prevent="search_emps"
                          >
                            <v-icon left> $search </v-icon>
                            Search
                          </v-btn>

                          <v-btn
                            rounded
                            color="secondary"
                            class="ml-2"
                            @click.prevent="clear_search_emps"
                          >
                            <v-icon left> $clear </v-icon>
                            Clear
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="srch_results.length > 0">
        <!-- ******** --- search results  *********** -->
        <v-col id="searchcol" cols="12">
          <div class="rect">
            <h3 class="red--text ml-2 ml-md-4">Search Results</h3>
            <v-expansion-panels v-model="panel2" accordion>
              <emp_panel
                v-for="emp in srch_results"
                :key="emp.idx"
                :emp="emp"
                @un_delete_emp="un_delete_emp"
                @open_diag_edit="open_diag_edit"
                @delete_emp="delete_emp"
              ></emp_panel>
            </v-expansion-panels>
          </div>
          <v-spacer></v-spacer>
        </v-col>
        <!-- <v-col id="panel1" cols="12" class="col-md-10">
            <div id="rect" style="background-color:whitesmoke; width: 98%;height:90vh;margin: auto;"></div>
        </v-col> -->
      </v-row>

      <v-row no-gutters v-show="srch_results.length == 0">
        <v-col id="maincol" cols="12">
          <div class="rect">
            <v-expansion-panels v-model="panel2" accordion>
              <emp_panel
                v-for="emp in newemps"
                :key="emp.idx"
                :emp="emp"
                @open_diag_edit="open_diag_edit"
                @delete_emp="delete_emp"
              ></emp_panel>
            </v-expansion-panels>
          </div>
          <v-spacer></v-spacer>
        </v-col>
        <!-- <v-col id="panel1" cols="12" class="col-md-10">
            <div id="rect" style="background-color:whitesmoke; width: 98%;height:90vh;margin: auto;"></div>
        </v-col> -->

        <v-btn
          v-if="mod_state != 'EDIT'"
          fab
          dark
          large
          color="red"
          fixed
          right
          bottom
          @click.prevent="open_dialog"
        >
          <v-icon>$plus</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </Transition>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#home-container {
  max-width: 768px;
  height: auto;
}
.rect {
  background-color: white;
  margin: auto;
  margin-top: 10px;
}
.dataitem {
  font-weight: 600;
}
.dataitem_width {
  font-weight: 600;
  width: 30%;
}
.casual_btn {
  width: 115px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
const addedit_diag = () => import("./addedit_diag.vue");
import emp_panel from "./emp_panel.vue";

export default {
  name: "Home",
  mixins: [bus_common],
  components: { auth, addedit_diag, emp_panel },
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      per_email_warning: false,
      lst_admin_emails: [],
      srch_results: [],
      search_expn: -1,
      del_intems: ["No", "Yes"],
      dialog: false,
      mod_state: "",
      lst_items: [
        {
          recid: 1,
          order: 1,
          name: "finger_prints",
          title: "FINGER PRINTS",
          done: true,
          date: "10/27/2021",
          email: "person@reno.gov",
        },
        {
          recid: 2,
          order: 1,
          name: "sec_aware",
          title: "SECURITY AWARENESS",
          done: true,
          date: "10/27/2021",
          email: "person@reno.gov",
        },
        {
          recid: 3,
          order: 1,
          name: "tib",
          title: "TIBURON",
          done: false,
          date: "1/1/1900",
          email: "person@reno.gov",
        },
        {
          recid: 4,
          order: 1,
          name: "badge",
          title: "BADGE ",
          done: false,
          date: "1/1/1900",
          email: "person@reno.gov",
        },
        {
          recid: 5,
          order: 1,
          name: "park",
          title: "PARKING PASS",
          done: false,
          date: "1/1/1900",
          email: "person@reno.gov",
        },
        {
          recid: 6,
          order: 1,
          name: "work_email",
          title: "WORK EMAIL",
          done: false,
          date: "1/1/1900",
          email: "person@reno.gov",
        },
      ],
      newemps: [],
      panel: -1,
      panel2: -1,
      valid: false,
      search_term: {
        fname: "",
        lname: "",
        dob: "",
        division: "",
        unit: "",
        deleted: "No",
        badge_emp_num: "",
      },
      new_search_term: {
        fname: "",
        lname: "",
        dob: "",
        division: "",
        unit: "",
        deleted: "No",
        notes: "",
        badge_emp_num: "",
      },
      new_emp: {
        fname: "",
        lname: "",
        dob: "1/1/0001",
        division: "",
        unit: "",
        st_date: "",
        divsion: "",
        supervisor: "",
        persons_cell: "",
        work_cell: "",
        personal_email: "",
        work_email: "",
        access_card_number: "",
        notes: "",
      },
      blank_emp: {
        fname: "",
        lname: "",
        dob: "1/1/0001",
        division: "",
        unit: "",
        st_date: "",
        divsion: "",
        supervisor: "",
        persons_cell: "",
        work_cell: "",
        personal_email: "",
        work_email: "",
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 60 characters",
      ],

      email: "",
      emp_types: [
        "Paid Employee",
        "Sworn",
        "Sworn Outside Agency",
        "Records",
        "PSS  ",
        "SAVE",
        "Vendor",
        "PSI (Public Service Intern) - employee",
        "Student Intern - non-employee",
        "Chaplin non-employee",
        "Volunteer",
      ],
      units: [
        "Victim Services",
        "Sex Crimes",
        "Robbery/Homicide",
        "Financial/Computer Crimes",
        "Burglary",
        "Family Crimes",
        "Records",
      ],
      div_names: [
        "Accounting",
        "Admin Clerical Support",
        "Admin Services Manager",
        "Auto Theft",
        "Backgrounds",
        "Backgrounds ATL",
        "DET Cell Phone (Bike Team)",
        "Burglary",
        "Business License Processing",
        "Child Abuse",
        "Community Action Office (CAO)",
        "Crime Analysis",
        "Detectives Main",
        "Dispatch Non Emergency 334-COPS",
        "Family Crimes",
        "Finance",
        "Financial Crimes/Fraud",
        "Front Desk Reception",
        "Northern Nev. Regional Intelligence Cente",
        "Graffiti (Reno Direct)",
        "Human Resources",
        "Internal Affairs",
        "Missing Persons Unit",
        "PIO (Public Information Officer)",
        "Records and ID",
        "RGU (Regional Gang Unit)",
        "RHU (Robbery/Homicide Unit)",
        "Ride-Along Program",
        "Regional Sex Offender Notification",
        "S.A.V.E.",
        "Sex Crimes",
        "South Sub Station",
        "Traffic",
        "Traffic Office / Investigation",
        "Work Cards",
        "Recruitment",
        "Secret Witness",
        "Street Enforcement Team (S.E.T.)",
        "Victim Services",
        "Property and Evidence",
        "Police Training Office",
        "K-9",
        "Community Outreach",
        "Grants",
        "LGBTQ Police Liaison",
      ],
    };
  },
  watch: {
    "$store.state.user": function () {
      let self = this;
      this.init();
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    per_email_warning_now() {
      this.per_email_warning = true;
    },
    clear_search_emps() {
      this.search_term = this.mno(this.new_search_term);
      this.srch_results = [];
      this.init();
    },
    search_emps(do_sawll) {
      if (
        this.search_term.lname == "" &&
        this.search_term.fname == "" &&
        this.search_term.division == "" &&
        this.search_term.unit == "" &&
        this.search_term.badge_emp_num == "" &&
        this.search_term.notes == ""
      ) {
        this.swall_it(
          "Search Term",
          "A search term is required to search for new employees. Please fill in the search form as needed.",
          "warning"
        );
        return true;
      }

      let self = this;

      let fromIn = this.mno(this.search_term);

      fromIn.apiname = "search_emps";
      fromIn.useremail = this.$store.state.user.email;
      fromIn.token = this.$store.state.user.token;

      if (fromIn.dob == "") {
        fromIn.dob = new Date("1/1/0001");
      }
      self.show_loader(true);

      this.$store
        .dispatch("anyapi", fromIn)
        .then((data) => {
          this.mod_state = "";
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.srch_results = self.mno(data);
          if (do_sawll.type == "click" || do_sawll == null) {
            // == click means the default event was passed in.
            if (self.srch_results.length == 0) {
              self.swall_it(
                "Search Complete",
                "No search results.  Try changing your search terms.",
                "warning"
              );
            } else {
              self.swall_it(
                "Search Complete",
                "New employees, if found are shown below. Clear search to restore browsing of new employees.",
                "success"
              );
            }
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    un_delete_emp(new_empId) {
      let self = this;

      let emp = {};
      emp.new_empId = new_empId;
      emp.apiname = "un_delete_emp";
      emp.email = this.$store.state.user.email;
      emp.token = this.$store.state.user.token;

      self.show_loader(true);

      this.$store
        .dispatch("anyapi", emp)
        .then((data) => {
          //if undleting likely need to close search by empyting array
          this.search_term = this.mno(this.new_search_term);
          this.srch_results = [];

          self.close_dialog();
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.newemps = self.mno(data);
          self.swall_it(
            "Saved",
            "The employee was successfully added back.",
            "success"
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_emp(new_empId) {
      let self = this;

      let emp = {};
      emp.new_empId = new_empId;
      emp.apiname = "delete_emp";
      emp.email = this.$store.state.user.email;
      emp.token = this.$store.state.user.token;

      self.show_loader(true);

      this.$store
        .dispatch("anyapi", emp)
        .then((data) => {
          self.close_dialog();
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.newemps = self.mno(data);
          if (self.srch_results.length > 0) {
            self.search_emps(false);
          }

          self.swall_it(
            "Saved",
            "The employee was successfully completed.",
            "success"
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_all_emps_items() {
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_all_emps_items";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.newemps = self.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_all_admin_emails() {
      //not doing this now.
      return true;

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_all_admin_emails";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.lst_admin_emails = self.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    save_added_emp(locemp) {
      this.show_loader(true);

      let added_emp = this.mno(locemp);
      added_emp.apiname = "save_newemp";
      added_emp.email = this.$store.state.user.email;
      added_emp.token = this.$store.state.user.token;

      added_emp.dob = new Date("1/1/1900");
      if (added_emp.st_date == "") {
        added_emp.st_date = new Date("1/1/1900");
      }
      if (locemp.finger_print_num == null) {
        locemp.finger_print_num = "";
      }
      if (locemp.notes == null) {
        locemp.notes = "";
      }
      let self = this;
      self.show_loader(true);
      this.$store
        .dispatch("anyapi", added_emp)
        .then((data) => {
          self.close_dialog();
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.newemps = self.mno(data);
          if (self.srch_results.length != 0) {
            this.search_emps(false);
          }
          self.panel2 = 0;
          self.swall_it(
            "Saved",
            "The employee was successfully saved.",
            "success"
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
          this.close_dialog();
        });
    },
    open_diag_edit(loc_emp) {
      // this.loc_emp.dob = "1/1/0001";
      this.new_emp = this.mno(loc_emp);
      this.mod_state = "EDIT";
      this.dialog = true;
    },
    close_dialog() {
      this.mod_state = "";
      this.dialog = false;
    },
    open_dialog() {
      this.mod_state = "ADD";
      this.new_emp = this.mno(this.blank_emp);
      this.dialog = true;
    },
    filter_nodate(value) {
      if (value === "1/1/1900") {
        return "No Date";
      } else {
        return value;
      }
    },
    toggle_item(item) {
      item.done = !item.done;
      if (item.done) {
        item.date = this.$moment().format("MM/DD/yyyy");
      } else {
        item.date = "1/1/1900";
      }
    },
    init: function () {
      this.show_loader(true);
      this.loc_new_emp = this.mno(this.new_emp);
      this.units.sort();
      this.units.unshift("Other");
      this.units.unshift("Not Applicable");

      this.div_names.sort();
      this.div_names.unshift("Other");
      this.div_names.unshift("Not Applicable");

      this.emp_types.sort();
      this.emp_types.unshift("Other");
      this.emp_types.unshift("Not Applicable");

      this.get_all_admin_emails();
      this.get_all_emps_items();
      this.search_expn = -1;
      //var self = this;
      //window.setInterval(function () {
      //    console.log("log");
      //    self.show_loader(true);
      //}, 3000)
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      // this.init(self);
    });
  },
};
</script>
